import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'app-hcpoa-agent',
    templateUrl: './hcpoa-agent.component.html',
    styleUrls: ['./hcpoa-agent.component.scss'],
    standalone: false
})
export class HcpoaAgentComponent implements OnInit{
  @Input() formGroup!: FormGroup;
  @Input() panelBarExpanded = false;
  public phoneMask = '(000) 000-0000';
  ngOnInit(): void {
  }

  public onStateChange(ev: any): void {
    console.log('inside on state changed');
    console.log(ev);
    // console.log(this.expandedItems);
    // this.expandedItems = expandedIndices;
  }

}
